import classes from './SkillsBlock.module.scss';

import { beskills, feskills, servers, productivity } from 'data';
import SkillGrid from 'components/layout/SkillGrid';

const SkillsBlock = () => {

	return(
		<div className={`${classes['skills-block']} flow`}>
		  <h2 className='section-title red center'>What I do</h2>
		  <div className={`${classes['skills-block__table']}`}>
				<div className={`${classes['skill-block']}`}>
					<h3 className="center black">Front-end Skills</h3>
					<SkillGrid skills={feskills} />
				</div>

				<div className={`${classes['skill-block']}`}>
					<h3 className="black center">Back-end Skills</h3>
					<SkillGrid skills={beskills} />
				</div>

				<div className={`${classes['skill-block']}`}>
					<h3 className="black center">Devops</h3>
					<SkillGrid skills={servers} />
				</div>

				<div className={`${classes['skill-block']}`}>
					<h3 className="black center">Tools & Productivity</h3>
					<SkillGrid skills={productivity} />
				</div>

		  </div>
		</div>
	)
}

export default SkillsBlock;